var _ = Object.defineProperty, x = Object.defineProperties;
var B = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var u = Object.prototype.hasOwnProperty, N = Object.prototype.propertyIsEnumerable;
var T = (o, n, i) => n in o ? _(o, n, { enumerable: !0, configurable: !0, writable: !0, value: i }) : o[n] = i, c = (o, n) => {
  for (var i in n || (n = {}))
    u.call(n, i) && T(o, i, n[i]);
  if (e)
    for (var i of e(n))
      N.call(n, i) && T(o, i, n[i]);
  return o;
}, a = (o, n) => x(o, B(n));
var d = (o, n) => {
  var i = {};
  for (var r in o)
    u.call(o, r) && n.indexOf(r) < 0 && (i[r] = o[r]);
  if (o != null && e)
    for (var r of e(o))
      n.indexOf(r) < 0 && N.call(o, r) && (i[r] = o[r]);
  return i;
};
import { jsxs as y, jsx as s } from "react/jsx-runtime";
import t from "../../../node_modules/prop-types/index.es.js";
import { forwardRef as F, useState as k } from "react";
import * as P from "./style.es.js";
import { Notification as $, NotificationBody as E } from "./style.es.js";
import { IconButton as U } from "../../Inputs/Button/IconButton.es.js";
import { Icon as O } from "../Icon/Icon.es.js";
import { Typography as h } from "../../Typography/Typography.es.js";
import { Button as z } from "../../Inputs/Button/Button.es.js";
const R = {
  toast: "348px",
  inline: ""
}, S = {
  success: "success",
  warning: "warning",
  error: "error",
  info: "info"
}, Y = {
  success: "f-success",
  warning: "f-warning",
  error: "f-error",
  info: "f-tooltip"
}, C = {
  inline: "inline",
  toast: "toast"
}, f = F((q, w) => {
  var I = q, {
    content: o,
    isClosable: n = !1,
    linkButton: i,
    message: r,
    onClose: l,
    status: p = S.success,
    title: m,
    type: b = C.inline
  } = I, g = d(I, [
    "content",
    "isClosable",
    "linkButton",
    "message",
    "onClose",
    "status",
    "title",
    "type"
  ]);
  const [v, A] = k(!0), j = () => {
    l && l(), A(!1);
  };
  return v ? /* @__PURE__ */ y($, a(c({ ref: w, $size: R[b], $status: p }, g), { children: [
    /* @__PURE__ */ s(O, { name: Y[p] }),
    /* @__PURE__ */ y(E, { children: [
      m && /* @__PURE__ */ s(h, { variant: "body2Bold", children: m }),
      r && /* @__PURE__ */ s(h, { variant: "body2", children: r }),
      o && o,
      i && /* @__PURE__ */ s(z, a(c({}, i), { variant: "link", color: "secondary" }))
    ] }),
    n && /* @__PURE__ */ s(U, { variant: "link", color: "secondary", children: /* @__PURE__ */ s(O, { name: "close", onClick: j }) })
  ] })) : null;
}), Z = {
  isClosable: t.bool,
  linkButton: t.object,
  message: t.string,
  onClose: t.func,
  status: t.oneOf(Object.values(S)),
  title: t.string,
  type: t.oneOf(Object.values(C))
};
f.displayName = "Notification";
f.S = P;
f.propTypes = Z;
export {
  R as NOTIFICATION_SIZE,
  S as NOTIFICATION_STATUS,
  Y as NOTIFICATION_STATUS_ICON,
  C as NOTIFICATION_TYPE,
  f as Notification,
  Z as notificationPropTypes
};
//# sourceMappingURL=Notification.es.js.map
